import config from "./config";
import { getHeaders, makeRequest } from "$utils/utils";

const url = config.api_url;

export enum WMSConfigERRORS {
  MISSING_FIELD = "Donnée manquante !",
  ADD_ERROR = "Une erreur s'est produite lors de l'ajout de la configuration du WMS",
  UPDATE_ERROR = "Une erreur s'est produite lors de l'édition de la configuration du WMS",
  GET_ALL_ERROR = "Une erreur s'est produite lors de la récupération des configuration du WMS",
}

export const CreateWMSConfig = async (token: string, data: any) => {
  try {
    const res = await makeRequest(
      `${url}/api/warehouse-sync-config`,
      "POST",
      data,
      getHeaders(token)
    );
    if (!res || !res.data || !res.data.status) {
      throw new Error(WMSConfigERRORS.ADD_ERROR);
    }
    return res.data.data;
  } catch (err) {
    let error = (err as any)?.response?.data?.message;
    if (error && error.includes("missing")) {
      error = WMSConfigERRORS.MISSING_FIELD;
    } else {
      error = WMSConfigERRORS.ADD_ERROR;
    }
    return { error };
  }
};

export const UpdateWMSConfig = async (
  token: string,
  data: any,
  id?: string
) => {
  try {
    const res = await makeRequest(
      `${url}/api/warehouse-sync-config/${id}`,
      "PUT",
      data,
      getHeaders(token)
    );
    if (!res || !res.data || !res.data.status) {
      throw new Error(WMSConfigERRORS.UPDATE_ERROR);
    }
    return res.data.data;
  } catch (err) {
    let error = (err as any)?.response?.data?.message;
    if (error && error.includes("missing")) {
      error = WMSConfigERRORS.MISSING_FIELD;
    } else {
      error = WMSConfigERRORS.UPDATE_ERROR;
    }
    return { error };
  }
};

// Get all WMSConfig
export const GetWMSConfig = async (token: string, warehouseId?: string) => {
  try {
    const res = await makeRequest(
      warehouseId
        ? `${url}/api/warehouse-sync-config/warehouse?warehouseId=${warehouseId}`
        : `${url}/api/warehouse-sync-config/`,
      "GET",
      undefined,
      getHeaders(token)
    );
    if (!res || !res.data || !res.data.status) {
      throw new Error(WMSConfigERRORS.GET_ALL_ERROR);
    }
    return res.data.data;
  } catch (err) {
    const error = (err as any)?.response?.data?.message;
    return { error };
  }
};

export const DeleteWMSConfig = async (token: string, id: string) => {
  try {
    if (!id) {
      throw new Error(WMSConfigERRORS.MISSING_FIELD);
    }
    const res = await makeRequest(
      `${url}/api/warehouse-sync-config/${id}`,
      "DELETE",
      undefined,
      getHeaders(token)
    );
    if (!res || !res.data || !res.data.status) {
      throw new Error(WMSConfigERRORS.GET_ALL_ERROR);
    }
    return res.data.data;
  } catch (err) {
    const error = (err as any)?.response?.data?.message;
    return { error };
  }
};
